import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const PRIMARY_COLOR = token('color.icon', colors.N500);
